export default __webpack_public_path__ + "static/Staatliches-Regular-bfa44729466e5770c54b8ef1a57a106a.otf";